/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react"
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, FormGroup, Modal } from "reactstrap";
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { useSelector, useDispatch } from "react-redux";
import { useHistory, withRouter, Link } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import banner from "../../assets/images/banner/banner.jpg";
import authHeader from "helpers/authHeader";
import FormLoader from "../JSBForms/FormLoader";
import { checkBranchLogin } from "../../helpers/fakebackend_helper";
import { use } from "react";
import { set } from "lodash";

const BranchLogin = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);

    // State to set authentication details
    const [authDetailsOfLanUser, setAuthDetailsOfLanUser] = useState(null);
    // Set the state if its a LAN environment?
    const [isLanEnv, setIsLanEnv] = useState(false);

    useEffect(() => {
        if (props && props.isLANEnv) {
            // console.log("LAN Environment Detected", props);
            const { isLANEnv, persistAuthDetailsForLan } = props;
            if (isLANEnv && persistAuthDetailsForLan) {
                setIsLanEnv(isLANEnv);
                setAuthDetailsOfLanUser(persistAuthDetailsForLan);
            }
        }

    }, [props])

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: '',
            password: '',
            showPassword: false,
        },
        validationSchema: Yup.object({
            username: Yup.string().required("User Name required"),
            password: Yup.string().required("Password required"),
        }),
        onSubmit: (values) => {
            //dispatch(BranchLoginUser(values, props.history));
        }

    });

    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    const textboxRounded = {
        color: "black",
        //fontSize: "larger"
    };

    const modalpopup = {
        border: "2px solid black", textAlign: "center", fontSize: "large", color: "black"
    };

    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px",
        width: "99%",
        backgroundColor: "rgb(247 242 242)"
    }

    const [modal_backdrop, setmodal_backdrop] = useState(false);
    const [guid, setguid] = useState("");
    const [isPreloader, setPreloader] = useState(false);

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    };

    function removeBodyCss() {
        document.body.classList.add("no_padding")
    };

    useEffect(() => {
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }
    }, [isPreloader]);

    function CheckBranchLogin(UserName, Password) {
        debugger;
        const checkUser = {
            username: UserName,
            password: Password
        };

        setPreloader(true);
        axios.post(checkBranchLogin(), checkUser, { headers: authHeader() })
            .then(response => {
                if (response.data != null) {
                    if (response.data.responseCode == "OK") {
                        console.log("Branch Login Success", response.data);
                        if (isLanEnv) {
                            props?.setAuthDetails({
                                ...authDetailsOfLanUser,
                                userName: response.data.emp.username,
                                branchCode: response.data.emp.lbrcode,
                                branchName: response.data.emp.lbrname.replace("\"", "").replace("\"", ""),
                            })
                        } else {
                            localStorage.setItem('branchToken', JSON.stringify(response.data.token));
                            localStorage.setItem('userName', JSON.stringify(response.data.emp.username));
                            localStorage.setItem('branchCode', JSON.stringify(response.data.emp.lbrcode));
                            localStorage.setItem('branchName', JSON.stringify(response.data.emp.lbrname).replace("\"", "").replace("\"", ""));
                            localStorage.setItem('isAdmin', JSON.stringify(response.data.emp.isAdmin));
                            localStorage.setItem('usedesc', JSON.stringify(response.data.emp.usedesc).replace("\"", "").replace("\"", ""));
                            history.push('/CustomerList');
                        }
                    }
                    else {
                        ErrorMessage(response.data.responseMessage);
                    }
                }

                setPreloader(false);
            }, (error) => {
                console.log(error.response);
                setPreloader(false);
            })
    }

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <MetaTags>
                <title>JSB-Branch Login</title>
            </MetaTags>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="fas fa-home h2" />
                </Link>
            </div>
            <div className="account-pages my-5 pt-sm-5">
                <Container fluid={true}>
                    <Row className="justify-content-center">
                        <Col md={6} lg={5} xl={4}>
                            <Card className="overflow-hidden" style={cardBackground}>
                                <div className="bg-primary bg-soft">
                                    <Row>
                                        <Col xs={12}>
                                            <img src={banner} alt="" className="img-fluid" style={{ width: "100%" }} />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div className="p-2">
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div className="mb-3">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label" style={{ color: "black" }}>User Name</Label><span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                    <Input autoFocus
                                                        id="txtUserName"
                                                        maxLength="10"
                                                        name="username"
                                                        value={validation.values.username || ""}
                                                        type="text"
                                                        min="1"
                                                        placeholder="User Name"
                                                        className="form-control"
                                                        style={textboxRounded}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.username && validation.errors.username ? true : false
                                                        }
                                                        autocomplete="off" 
                                                    />
                                                    {validation.touched.username && validation.errors.username ? (
                                                        <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </div>

                                            <div className="mb-3">
                                                <FormGroup className="mb-3">
                                                    <Label className="form-label" style={{ color: "black" }}>Password</Label><span style={{ color: "red", fontWeight: "bold" }}>*</span>
                                                    <Input
                                                        id="txtPassword"
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type="password"
                                                        maxLength="16" 
                                                        placeholder="Password"
                                                        className="form-control"
                                                        style={textboxRounded}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                        autocomplete="off"
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                </FormGroup>
                                            </div>

                                            <div className="mt-3 d-grid">
                                                <button
                                                    style={{ backgroundColor: "#9a084f", fontSize: "larger", borderRadius: "0.75rem" }}
                                                    className="btn btn-primary btn-block"
                                                    type="submit"
                                                    onClick={() => {
                                                        debugger;
                                                        if (validation.values.username != "" && validation.values.password != "") {
                                                            CheckBranchLogin(validation.values.username, validation.values.password);
                                                        }
                                                    }
                                                    }
                                                    data-toggle="modal"
                                                >
                                                    Login
                                                </button>
                                                <Modal autoFocus={false}
                                                    isOpen={modal_backdrop}
                                                    toggle={() => {
                                                        tog_backdrop();
                                                    }}
                                                    backdrop={'static'}
                                                    id="staticBackdrop"
                                                    className="modal-dialog modal-dialog-centered"
                                                >
                                                </Modal>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <footer style={{ backgroundColor: "#333333", color: "white", height: "50px", position: "absolute", bottom: "0" }}>
                            <Container fluid={true}>
                                <Row>
                                    <Col style={{ marginTop: "15px" }} md={6}> &copy; 2022 all rights reserved</Col>
                                    <Col style={{ marginTop: "15px" }} md={6}>
                                        <div className="text-sm-end d-none d-sm-block">
                                            Powered by ZingWorks LLP
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </footer>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
};

export default BranchLogin

BranchLogin.propTypes = {
    history: PropTypes.object,
};


